import { render, staticRenderFns } from "./OFPackagingInput.vue?vue&type=template&id=765868ad&scoped=true"
import script from "./OFPackagingInput.vue?vue&type=script&lang=js"
export * from "./OFPackagingInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765868ad",
  null
  
)

export default component.exports